import { css } from '@nfront/global-styles'

export default css`
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }
  body {
    font-family: ${(props) => props.theme.fontFamily.normal};
    color: ${(props) => props.theme.colors.black};
    overflow: ${(props) => (props.shouldDisableScroll ? 'hidden' : 'auto')};
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Cookie settings - Segment cookie modal */
  div[data-consent-manager-dialog] .css-ueuzok {
    z-index: 3000000000;
    right: auto;
    bottom: auto;
    height: 100%;
    width: 100%;
    max-width: none;
  }
  div[data-consent-manager-dialog] .css-1qpz2cf {
    max-width: calc(100% - 16px);
    max-height: calc(100% - 16px);
  }
  div[data-consent-manager-dialog] {
    /* "save" btn */
    .css-ueuzok .css-1g3391b {
      background-color: #2843a4;
      background-image: linear-gradient(to top, #2e4aad, #2843a4);
    }
    .css-ueuzok .css-1g3391b:hover {
      background-color: #344fb2;
      background-image: linear-gradient(to top, #3b57ba, #344fb2);
    }
  }

  //------FriendBuy popup -------------//
  div[id*='frndby_container'] img[id*='frndby_unit_loading'] {
    top: 5% !important;
    animation-name: fadeOut;
    animation-duration: 0.5s;
    opacity: 0;
  }

  div[id*='frndby_unit'] {
    position: absolute !important;
    margin: 0 !important;
    top: 60% !important;
    left: 50% !important;
    max-width: 0 !important;
    min-width: 290px !important ;

    transform: translate(-50%, -50%) !important;

    @media (min-width: 375px) {
      position: absolute !important;
      margin: 0 !important;
      top: 50% !important;
      left: 50% !important;
      max-width: 0 !important;
      min-width: 330px !important ;
      /* min-height: 330px !important ; */
      /* max-height: 330px !important ; */
      /* height: 600px !important; */
      transform: translate(-50%, -50%) !important;
    }

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      display: block !important;
      position: absolute !important;
      left: 50% !important;
      margin: 0 !important;
      max-width: 1100px !important;
      min-width: 320px !important;
      height: 560px !important;
      width: 100% !important;
      text-align: left !important;
      top: 50% !important;
      visibility: visible !important;
      z-index: 999998 !important;
      overflow: hidden !important;
      transform: translate(-50%, -50%) !important;
    }
  }
  div[id*='frndby_unit'] div[id*='frndby_close_btn'] img {
    margin-right: 25px;
    margin-top: 5px;
    max-width: 18px !important;

    @media (min-width: 375px) {
      margin-right: 15px;
      margin-top: 10px;
      max-width: 18px !important;
    }
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      max-width: 32px !important;
      margin-right: 15px;
      margin-top: 10px;
    }
  }

  strong {
    font-family: ${(props) => props.theme.fontFamily.bold};
  }

  b {
    font-family: ${(props) => props.theme.fontFamily.bold};
  }

  *:focus {
    outline: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button,
  input {
    border: 0;
    background: transparent;
    margin: 0;
    padding: 0;
    outline: 0;
    -webkit-font-smoothing: antialiased;
  }

  input,
  textarea,
  button,
  select,
  div,
  a {
    -webkit-tap-highlight-color: transparent;
  }
`
